import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function StarIcon(props) {
  return (
    <SvgIcon viewBox="0 0 61 60" {...props}>
      <title>Star</title>
      <g>
        <path d="M30.2867 3.75C29.4911 3.75 28.6978 4.16451 28.288 4.99115L21.5153 18.7129C21.1913 19.3704 20.5648 19.8278 19.8382 19.9326L4.69669 22.1314C2.86712 22.3982 2.14054 24.6447 3.4603 25.9334L14.4186 36.613C14.9451 37.1252 15.1833 37.8637 15.0571 38.5879L12.4723 53.6675C12.2246 55.1088 13.3681 56.2761 14.6664 56.2761C15.0118 56.2761 15.3644 56.1951 15.705 56.0164L29.2481 48.8959C29.5745 48.7244 29.9318 48.6386 30.2867 48.6386C30.6417 48.6386 30.999 48.7244 31.3254 48.8959L44.8661 56.0164C45.2091 56.1951 45.5617 56.2761 45.9047 56.2761C47.2031 56.2761 48.3465 55.1088 48.1012 53.6675L45.514 38.5879C45.3902 37.8637 45.6284 37.1252 46.1549 36.613L57.1108 25.9334C58.433 24.6447 57.704 22.3982 55.8768 22.1314L40.7353 19.9326C40.0087 19.8278 39.3798 19.3704 39.0582 18.7129L32.2854 4.99115C31.8757 4.16451 31.08 3.75 30.2867 3.75ZM30.2867 14.401L33.7148 21.35C34.9059 23.7656 37.2095 25.4379 39.8777 25.8262L47.5461 26.9411L41.9979 32.3488C40.0659 34.2284 39.1868 36.937 39.6442 39.5932L40.9544 47.2307L34.096 43.6264C32.9239 43.0094 31.6089 42.683 30.2867 42.683C28.9646 42.683 27.6472 43.0094 26.4775 43.624L19.6191 47.2307L20.9293 39.5932C21.3867 36.937 20.5053 34.2284 18.5756 32.3488L13.0274 26.9411L20.6958 25.8262C23.3616 25.4379 25.6652 23.7656 26.8587 21.35L30.2867 14.401Z" />
      </g>
    </SvgIcon>
  );
}

export default StarIcon;
